import React from 'react';

import './SimpleLoginPage.css';
import logo from 'static/img/logo-white.svg';

const AuthenticationRedirectPage = () => {
    
    return (
        <div className="SimpleLogin">
            <img className="SimpleLogin-logo" src={logo} alt="Burn for Money" />
        </div>
    );
}

export default AuthenticationRedirectPage;



// WEBPACK FOOTER //
// ./src/components/Authentication/AuthenticationRedirectPage.js